<!--
 * @Description: 日程会场列表页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-06-23 12:25:55
 * @LastEditors: 山淑兰
 -->
<template>
    <div class="roomlist">
        <div class="loading" v-if="loading">
            <van-loading color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
        </div>
        <!-- <div class="guest-nav-fixed">
            {{fixedLetter}}
        </div> -->
        <div class="guest-con">
            <div class="guestlist" v-for="(item,index) in pinYinList" :key="index" :ref="`pinyin${index}`">
				<template v-if="$i18n.locale === 'zh-CN'">
					<div class="guest-list" :id="'guest-'+ index" v-for="(items,indexs) in expertList[item]" :key="indexs" @click="godetail(items.exid)">
						<div class="guest-photo">
							<img :src="items.photo || this.defaultHeadImg" alt />
						</div>
						<div class="guest-info">
							<div class="guest-cname" v-html="nToBr(items.cname)">
							</div>
							<div class="guest-cncompany" v-html="nToBr(items.cncompany)">
							</div>
							<div class="guest-cnintroduction" v-if="introShow">
								{{items.cnintroduction}}
								<span>查看详情</span>
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="guest-list" :id="'guest-'+ index" v-for="(items,indexs) in expertList[item]" :key="indexs" @click="godetail(items.exid)">
						<div class="guest-photo">
							<img :src="items.photo || this.defaultHeadImg" alt />
						</div>
						<div class="guest-info">
							<div class="guest-cname" v-html="items.enname!=null&&items.enname!=''?nToBr(items.enname):nToBr(items.cname)">
							</div>
							<div class="guest-cncompany" v-html="items.encompany!=null&&items.encompany!=''?nToBr(items.encompany):nToBr(items.cncompany)">
							</div>
							<div class="guest-cnintroduction" v-if="introShow">
								{{items.enintroduction!=null&&items.enintroduction!=''?items.enintroduction:items.cnintroduction}}
								<span>more</span>
							</div>
						</div>
					</div>
				</template>
            </div>
            <div class="guset-nav" :class="fixed?'fixed':''">
                <div class="letter-t" v-for="(item,index) in pinYinList" :key="index" :class="activeBtn==index?'weight':''" @click="goGuest('#guest-'+index,index)">
                    {{item}}
                </div>
            </div>
        </div>
        <div class="modal" v-if="modalShow">
            <div class="details-conss">
                <DetailsNews :exid="exid" :introStatus="introShow" @func="closeGuest" />
            </div>
        </div>
    </div>
</template>
<script>
    import defaultHeadImg from '../../../assets/defaultHeadImg.png'
import DetailsNews from './detail.vue';
export default {
    name: 'place',
	props: ['introShow'],
    components: {
        DetailsNews
    },
    data() {
        return {
            loading: false,
            loading1: false,
            pinYinList: [],
            expertList: [],
            m: '',
            dateid: 0,
            roomid: 0,
			rid: 0,
            search: '',
            defaultHeadImg,
            modalShow: false,
            exid: '',
            fixed: false,
            activeBtn: -1,
            fixedLetter: '',
        }
    },
    watch: {
        $route(to, from) {
            if (to.query.dateid != from.query.dateid && to.query.dateid) {
                this.dateid = to.query.dateid
                this.init()
            }
        },
    },
    created() {
        if (this.$route.query) {
            this.dateid = this.$route.query.dateid
            this.init()
        }
        this.fixed = false
        document.addEventListener('scroll', this.handleScroll, true)
    },
    beforeDestroy () {
        document.removeEventListener('scroll', this.handleScroll, true);
    },
    methods: {
        handleScroll(){
            //var a = document.getElementsByClassName('guest-con')[0].offsetHeight;
            let that = this
            // let i = 1
            // console.log(that.$refs[`pinyin${i}`][0].getBoundingClientRect().top)
            this.$nextTick(() => {    
                for( let i in that.pinYinList ){
                    let pinyinHeight = that.$refs[`pinyin${i}`][0].getBoundingClientRect().top
                    if( pinyinHeight <= 20 ){
                        that.activeBtn = i
                    }
                }
            })
            
            if( window.pageYOffset >= 206 ){
                this.fixed = true
            }else{
                this.fixed = false
                that.activeBtn = -1
            }
        },
        goGuest(selector, index) {
            this.activeBtn = index;
            this.$el.querySelector(selector).scrollIntoView()
        },
        async init() {
            try {
                this.loading = true
                const {
                    m,
                    dateid = this.dateid,
                    roomid = this.roomid,
                    search = this.search,
                } = this.$route.query //获得路由的参数
                this.m = m

                const _params = {
                    m: this.m
                }
                const res = await this.$http.getProDateRoom(_params)
                this.$emit('searchDatas', res.childens)
                console.log(res.childens)

                this.guestList()

                this.loading = false
            } catch (error) {
                console.error(error)
            }

            // this.$toast.clear(false); //关闭加载动画
        },

        async guestList(){
            try {
                const {
                    m,
                    roomid = this.roomid,
                    search = this.search,
					rid = this.rid,
                } = this.$route.query //获得路由的参数
                this.m = m
                const _params = Object.assign({ m, roomid, rid },
                    search ? { search } : {}
                ) //search 是空字符串 为false 有值是true

                const res = await this.$http.getExpertProList(_params)
                console.log(res)
                this.expertList = res.ExpertList
                this.pinYinList = res.PinYinList
                if (this.pinYinList.includes('#') && (!this.expertList['#'] || this.expertList['#'].length === 0)) {
                    this.pinYinList = this.pinYinList.filter(item => item !== '#')
                }
            } catch (error) {
                console.error(error)
            }
        },

        godetail(id) {
            this.exid = id
            this.modalShow = true
        },
        closeGuest(){
          this.modalShow = false
        },
        nToBr (str){
            if( str ){
                return str.replace(/\\n/g,'<br/>');
            }else{
                return str
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.roomlist {
    margin-bottom: 80px;
    font-size: 26px;
    line-height: 1.5;

    .guest-con {
        position: relative;
        padding: 0 40px 20px 20px;
    }

    .guestlist {
        .guest-list {
            background: #fff;
            padding: 20px;
            margin-top: 20px;
            border: 1px soild #f6f6f6;
            display: flex;

            .guest-photo {
                width: 180px;
                margin-right: 20px;

                img {
                    width: 180px;
                    height: 180px;
                    border-radius: 50%;
                }
            }

            .guest-info {
                flex: 1;

                .guest-cname {
                    font-size: 32px;
                }

                .guest-cncompany {
                    font-size: 28px;
                    color: #666;
                }

                .guest-cnintroduction {
                    position: relative;
                    font-size: 28px;
                    line-height: 42px;
                    color: #999;
                    display: -webkit-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
					word-break: break-all;
                    span {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        background: #fff;
                        z-index: 2;
                        color: #3b82f6;
                        box-shadow: -1px 0 2px #fff;
                        display: block;
                    }
                }
            }
        }
    }

    .guest-nav-fixed {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        height: 60px;
        z-index: 100;
        background: #f0f0f0;
    }

    .guset-nav {
        position: absolute;
        top: 0;
        right: 0;
        width: 40px;
        height: 100%;
        z-index: 100;
        background: #f0f0f0;
        color: #333;
        opacity: 0.8;

        .letter-t {
            font-size: 30px;
            line-height: 50px;
            text-align: center;
        }

        .weight {
            font-weight: bold;
        }
    }

    .fixed {
        position: fixed;
    }
}

.modal {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 1000;

    .loading {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10002;
    }

    .details-conss {
        background: #fff;
        // padding: 20px 0;
        // -webkit-box-shadow: 0 1px 0.125rem rgba(0, 0, 0, 0.3);
        // box-shadow: 0 1px 0.125rem rgba(0, 0, 0, 0.3);
        //border-radius: 15px;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 10001;
        width: 100%;
        height: 70%;
        overflow-y: auto;
        border-radius: 20px 20px 0 0;
        #guestIntroduction-con {
            margin-top: 15px;
            padding: 10px 0;

            >h4 {
                font-size: 26px;
                border-bottom: 1px solid #ccc;
                padding: 16px 20px;
                background: #3b82f6;
                border-radius: 15px 15px 0 0;
                color: #fff;
                margin-bottom: 10px;
            }

            >p {
                padding: 0 20px;
            }
        }
    }

    .details-head {
        position: relative;
        background: #3b82f6;
        display: flex;
        padding: 20px;
        color: #fff;

        .guest-headimg {
            text-align: center;
            margin-right: 20px;
            width: 160px;
            height: 160px;
            border-radius: 160px;

            img {
                width: 100%;
                height: 100%;
                border-radius: 160px;
            }
        }

        .guest-intro {
            margin-top: 20px;
            font-size: 28px;

            .host,
            .guest-name {
                margin-top: 8px;
            }
        }

        .guest-close {
            position: absolute;
            right: 30px;
            top: 30px;
            width: 50px;
            height: 50px;
            background: rgba(255, 255, 255, 1);
            border-radius: 25px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                display: block;
                width: 36px;
                height: 36px;
            }
        }
    }

    .details-tab {
        margin: 30px 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #e2e8f0;
        padding-bottom: 10px;

        li {
            padding: 0 30px;
        }

        li.active {
            position: relative;
            color: #3b82f6;
        }

        li.active:after {
            position: absolute;
            display: block;
            content: '';
            height: 4px;
            left: 40px;
            right: 40px;
            bottom: -10px;
            background: #3b82f6;
        }
    }

    .details-title {
        margin: 20px 10px;
        font-size: 28px;
        color: #000;

        span {
            display: inline-block;
            margin: 0px 18px;
            line-height: 60px;
            height: 60px;
        }

        &>div {
            height: 30%;
            font-size: 28px;

            .synopsis {
                .synopsis-tit {
                    height: 60px;
                    line-height: 60px;
                    background: #ccc;
                    padding-left: 10px;
                }
            }

            .van-icon {
                color: #fff;
            }
        }
    }

    .details-main {

        //padding-bottom: 30px;
        >div {
            background: #fff;
            margin-bottom: 24px;
            // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            border-bottom: 1px solid #e2e8f0;
        }

        .meeting-list {
            display: flex;
            margin-bottom: 10px;
            padding: 10px 20px 10px 22px;
            position: relative;

            .meeting-left {
                flex: 1
            }

            .meeting-icon {
                position: absolute;
                right: 0;
                top: 20px;
                z-index: 10;
                width: 160px;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                background: #3b82f6;
                padding: 10px 0;
                border-radius: 50px 0 0 50px;

                a {
                    color: #fff;
                    display: block;
                    text-align: center;
                }

                img {
                    width: 30px;
                    vertical-align: -4px;
                }

                p {
                    font-size: 12px;
                }
            }

            .meeting-icons {
                width: 100px;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                a {
                    color: #333;
                    display: block;
                    text-align: center;
                }

                img {
                    width: 90px;
                }

                img.arrow {
                    width: 30%;
                }
            }
        }

        .details-main-head {
            // border-bottom: 1px solid #ccc;
            //padding: 10px 0px;
            display: flex;

            // background: #3b82f6;
            // border-radius: 15px 15px 0 0;
            .details-main-head-date {
                color: #0e0ea5;
                padding: 0px 0px 0px 20px;
                font-size: 28px;

                &>.van-icon {
                    font-size: 40px;
                    line-height: 40px;
                }

                &:after {
                    border: none;
                }

                span {
                    line-height: 40px;
                }
            }

            .van-cell {
                background: none;
                color: #FF8F09;
            }

            .details-list-num {
                width: 40px;
                height: 40px;
                font-size: 28px;
                margin-right: 20px;
                border-radius: 12px;
                color: #fff;
                text-align: center;
                line-height: 40px;
            }
        }

        .details-main-con {
            position: relative;
            color: #000;

            // border-bottom: 1px solid #ccc;
            .major-title {
                padding: 8px 0px;
                font-size: 26px;
                color: #000;
                line-height: 36px;

                >i {
                    width: 36px;
                    font-size: 36px;
                    line-height: 36px;
                }

                >div {
                    color: #000;
                }

                &:after {
                    border: 0px;
                }
            }
        }

        .details-main-con.van-cell {
            padding: 0;
        }

        #guestIntroduction-con {
            min-height: 300px;
            margin-top: 20px;

            >h4 {
                font-size: 30px;
                padding-left: 20px;
                height: 60px;
                line-height: 60px;
                border-bottom: 1px solid #ccc;
                padding: 16px 0px;
                display: flex;
                background: #3b82f6;
                border-radius: 15px 15px 0 0;
            }

            >p {
                width: 90%;
                margin: 0 auto;
                padding: 20px 0;
                line-height: 54px;
            }
        }
    }
}
</style>
<style type="text/css">
.roomlist .van-popup__close-icon {
    font-size: 50px;
}
</style>